module.exports = __webpack_public_path__ + "static/img/towncircle.368fc5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/styles/mailkit/img/towncircle.png
// module id = C3eY
// module chunks = 1